import { Controller } from "@hotwired/stimulus";

// Impersonation straight from the account menu: the trigger swaps itself for a
// focused user search, and picking someone posts immediately. The choice is
// the whole decision, so a drawer round trip and a separate submit button are
// pure ceremony.
export default class extends Controller {
  static targets = ["trigger", "picker", "select"];

  declare readonly triggerTarget: HTMLElement;
  declare readonly pickerTarget: HTMLElement;
  declare readonly selectTarget: HTMLSelectElement;
  declare readonly hasSelectTarget: boolean;

  open(event: Event) {
    event.preventDefault();
    this.triggerTarget.classList.add("hidden");
    this.pickerTarget.classList.remove("hidden");

    // The select is display:none until the line above, so TomSelect cannot
    // place its dropdown yet — focus once the picker has painted.
    requestAnimationFrame(() => this.tomSelect?.focus());
  }

  // Focus leaving the menu is what closes it, so put the trigger back and let
  // the menu reopen in its resting state.
  reset(event: FocusEvent) {
    if (!this.hasSelectTarget) return;
    if (this.element.contains(event.relatedTarget as Node | null)) return;

    this.triggerTarget.classList.remove("hidden");
    this.pickerTarget.classList.add("hidden");
  }

  // Fires for every value change, the clear button included; only a real pick
  // should submit.
  submit(event: CustomEvent) {
    if (!event.detail?.value || !this.hasSelectTarget) return;

    this.selectTarget.form?.requestSubmit();
  }

  private get tomSelect(): { focus: () => void } | undefined {
    return this.hasSelectTarget
      ? (this.selectTarget as any).tomselect
      : undefined;
  }
}
